<template>
  <div class="earning">
    <div class="box">
      <img
        v-if="info.project"
        class="bg"
        :src="info.project.poster"
        @error="nofind()"
      />
      <van-row class="item" :class="{ isiOSX: isiOSX }">
        <van-col span="24" class="item-bg">
          <img @click="prev" src="../../assets/myInvest/reback1.png" alt />
        </van-col>
      </van-row>
      <van-row class="item other">
        <van-col span="24" class="item1" v-if="info.project">
          <img
            v-if="info.shares != 0 && info.project.status != -3"
            style="width: 97px"
            src="../../assets/myInvest/get1.png"
            alt
          />
          <img
            v-if="info.shares == 0 && info.project.status != -3"
            style="width: 71px"
            src="../../assets/myInvest/refund.png"
            alt
          />
          <img
            v-if="info.project.status == -3"
            style="width: 84px"
            src="../../assets/myInvest/stop.png"
            alt
          />
        </van-col>
        <van-col span="24" class="item2" v-if="info.project">{{
          info.project.project_name
        }}</van-col>
        <van-col span="24" class="item3" v-if="info.project"
          >我的持股 {{ info.shares }}股</van-col
        >
      </van-row>
    </div>
    <van-swipe
      class="bonus_list"
      :autoplay="3000"
      @change="onChange"
      v-if="swiper.length > 0"
    >
      <van-swipe-item v-for="(item, index) in swiper" :key="index">
        <van-row class="dividend">
          <van-col class="dividend_" span="24">
            <span class="border"></span>
            <span class="earn">我的众筹分红</span>
            <span class="order_sn" v-if="item.orders"
              >订单 {{ item.orders[0].ordersn }}</span
            >
          </van-col>
          <van-col span="9" class="total">
            <p>众筹分红红包</p>
            <p class="margin_top">
              <span>{{ item.dividend_amount[0] }}</span
              ><span class="point">.{{ item.dividend_amount[1] }}</span>
            </p>
          </van-col>
          <van-col
            span="8"
            class="total"
            v-if="
              item.latest_dividend && item.latest_dividend.dividend_amount > 0
            "
          >
            <p>下次分红红包</p>
            <p class="margin_top">
              <!--<span v-if="info.project && info.project.id == 23">待定</span>-->
              <span>{{ item.latest_dividend.dividend_amount_1[0] }}</span
              ><span class="point"
                >.{{ item.latest_dividend.dividend_amount_1[1] }}</span
              >
            </p>
          </van-col>
          <van-col
            span="7"
            class="total border_l"
            v-if="
              item.latest_dividend && item.latest_dividend.dividend_amount > 0
            "
          >
            <p class="text_right">众筹分红时间</p>
            <p class="margin_top-15">{{ item.next_dividend_time }}</p>
          </van-col>
        </van-row>
      </van-swipe-item>
      <div class="custom-indicator" slot="indicator">
        <span class="indexes"
          ><span class="left">{{ label + 1 }}</span
          ><span class="right">/{{ slideLen }}</span></span
        >
      </div>
    </van-swipe>

    <van-row class="tab_change">
      <van-col class="tab_change_" span="24">
        <span class="border"></span>
        <span class="earn">我的众筹收益</span>
      </van-col>
      <van-col span="24" class="tab_content">
        <swiper :options="swiperOption">
          <swiper-slide class="swiper_l">
            <div class="xb">
              <div class="integral">
                <span>今日新增积分</span>
                <span class="integral_" @click="creditList">
                  明细
                  <img src="../../assets/myInvest/route.png" alt />
                </span>
              </div>
              <p class="fraction" v-if="today_credits">
                +{{ today_credits[0] }}.<span>{{ today_credits[1] }}</span>
              </p>
              <div class="xb_coin">
                <div class="xb_">
                  <p>账户当前积分</p>
                  <p class="xb_num left_xb_num">
                    {{ now_credits[0] }}.{{ now_credits[1] }}
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper_r">
            <div class="xb">
              <div class="integral right_integral">
                <span class="integral_" @click="coinList">
                  明细
                  <img src="../../assets/myInvest/route.png" alt />
                </span>
                <div class="xb_ xb__">
                  <p class="title">今日持股收益</p>
                  <p class="fraction right_fraction" v-if="today_coin">
                    +{{ today_coin[0] }}.<span>{{ today_coin[1] }}</span>
                  </p>
                </div>
                <div class="xb_ xb__">
                  <p class="title">总众筹分红红包</p>
                  <p class="fraction right_fraction">
                    {{ bonus_coin[0] }}.<span>{{ bonus_coin[1] }}</span>
                  </p>
                </div>
                <p style="clear: both"></p>
              </div>
              <div class="xb_coin">
                <div class="xb_">
                  <p>总红包收益</p>
                  <p class="xb_num" v-if="info.account">
                    {{ info.account.totalCoin }}
                  </p>
                </div>
                <div class="xb_">
                  <p>可提现红包</p>
                  <p class="xb_num">{{ now_coin[0] }}.{{ now_coin[1] }}</p>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </van-col>
    </van-row>
    <van-row class="withdraw">
      <van-col span="24" class="btn-">
        <span class="btn_l" @click="apply()" v-if="info.shares != 0"
          >申请退股</span
        >
        <span class="btn_r" @click="invest_withdraw()">立即转出</span>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import defaultImg from "@/assets/common/ListPreload.png";
export default {
  data() {
    return {
      swiper: [],
      label: 0,
      slideLen: 0, //轮播length
      swiperOption: {
        slidesPerView: 1.2,
        slidesOffsetBefore: 16,
        freeMode: true,
        hide: false,
      },
      info: {},
      bonus_amount: 0,
      bonus_coin: [0, "0000"],
      today_credits: [0, "0000"],
      now_credits: [0, "0000"],
      today_coin: [0, "0000"],
      now_coin: [0, "0000"],
      bonus_coin_all: [0, "0000"],
      total_bonus_coin: [0, "0000"],
      isiOSX: false,
      withData: {},
    };
  },
  created() {
    this.getInfo();
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    getInfo() {
      this.$api
        .get("/investment/member/project/dividend", {
          project_id: this.$route.query.id,
        })
        .then((res) => {
          this.withData = {
            now_coin: res.account.nowCoin,
            coinId: res.account.coinId,
            projectId: res.project.id,
          };

          for (let i in res.dividends) {
            res.dividends[i].next_dividend_time = res.dividends[
              i
            ].next_dividend_time.slice(0, 10);
            this.bonus_amount += Number(res.dividends[i].dividend_amount);
            if (res.dividends[i].latest_dividend) {
              res.dividends[i].latest_dividend.dividend_amount_1 =
                this.tranform(
                  res.dividends[i].latest_dividend.dividend_amount + ""
                ); //下次分红红包
            }
            res.dividends[i].dividend_amount = this.tranform(
              res.dividends[i].dividend_amount + ""
            ); //订单分红总红包
          }
          res.account.totalCoin = Number(res.account.totalCoin).toFixed(4);

          this.swiper = res.dividends;
          this.slideLen = this.swiper.length;
          this.info = res;
          //res.account.totalCoin                //类型：Number  必有字段  备注：总返还红包
          this.bonus_coin = this.tranform(this.bonus_amount); //总分红红包
          this.today_credits = this.tranform(res.account.todayCreditsIncrease); //今日新增积分
          this.now_credits = this.tranform(res.account.nowCredits); //当前积分
          this.today_coin = this.tranform(res.account.todayCoinIncrease); //今日新增红包
          this.now_coin = this.tranform(res.account.nowCoin); //当前红包
        });
    },
    apply() {
      this.$router.push({
        path: "/myInvest/selectRefund",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    invest_withdraw() {
      this.params(
        JSON.stringify(this.withData),
        JSON.stringify(this.withData),
        "invest_withdraw"
      );
    },
    creditList() {
      //积分明细
      if (this.info && this.info.account) {
        this.$router.push({
          path: "/myInvest/points",
          query: {
            id: this.info.account.creditsId,
          },
        });
      }
    },
    coinList() {
      //红包明细
      if (this.info && this.info.account) {
        this.$router.push({
          path: "/myInvest/coins",
          query: {
            id: this.info.account.coinId,
          },
        });
      }
    },
    prev() {
      this.$router.go(-1);
    },
    tranform(data) {
      if (data != null && data != 0) {
        data = Number(data).toFixed(4) + "";
        let arr = [data.split(".")[0], data.split(".")[1]];
        return arr;
      } else {
        return [0, "0000"];
      }
    },
    onChange(index) {
      //轮播切换
      this.label = index;
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less" scoped>
.earning {
  position: relative;
  background-color: #f2f2f2;
  min-height: 100%;
  margin-bottom: 8px;
  .bonus_list {
    position: relative;
    .custom-indicator {
      position: absolute;
      top: 13px;
      right: 16px;
      .left {
        color: #333;
        font-size: 18px;
      }
      .right {
        color: #c0c0c0;
        font-size: 12px;
      }
    }
  }
  .box {
    height: 281px;
    position: relative;
    z-index: 0;
    .bg {
      width: 100%;
      height: 100%;
    }

    .item {
      padding-top: 24px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;

      .item-bg {
        padding-left: 15px;
        padding-top: 15px;
        img {
          width: 16px;
          height: 18px;
        }
      }
    }
    .isiOSX {
      padding-top: 44px;
    }
    .other {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 0;
      top: auto;
      background: -webkit-linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(0, 0, 0, 0.9)
      ); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(0, 0, 0, 0.9)
      ); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(0, 0, 0, 0.9)
      ); /* Firefox 3.6 - 15 */
      background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.9));
      .item1 {
        /*margin-top: 102px;*/
        padding-left: 16px;
      }
      .item2 {
        padding-left: 16px;
        font-size: 24px;
        line-height: 36px;
        color: #ffffff;
        margin-top: 6px;
        font-weight: 600;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .item3 {
        padding-left: 16px;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        font-weight: 500;
        margin-bottom: 16px;
      }
    }
  }
  .dividend {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 8px;
    .dividend_ {
      display: flex;
      position: relative;
      margin-bottom: 12px;
      .border {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: rgba(196, 158, 128, 1);
      }
      .earn {
        font-size: 18px;
        line-height: 25px;
        font-weight: 600;
        color: #333333;
        margin-left: 11px;
      }
      .order_sn {
        color: #c0c0c0;
        font-size: 12px;
        font-weight: normal;
        margin-left: 10px;
        line-height: 25px;
      }
    }
    .total {
      p {
        font-size: 13px;
        color: #333333;
        line-height: 18px;
        span {
          font-size: 20px;
          line-height: 21px;
          color: #d29a6e;
          font-weight: 500;
        }
        .point {
          font-size: 12px;
        }
      }
      .margin_top {
        margin-top: 8px;
      }
      .text_right {
        text-align: right;
      }
      .margin_top-15 {
        text-align: right;
        margin-top: 15px;
        line-height: 14px;
        color: #999999;
        padding-right: 4px;
      }
    }
    .border_l {
      border-left: 1px solid #eeeeee;
    }
  }
  .tab_change {
    padding: 16px 0;
    background-color: #fff;
    .tab_change_ {
      padding: 0 16px;
      display: flex;
      position: relative;
      margin-bottom: 12px;
      .border {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: rgba(196, 158, 128, 1);
      }
      .earn {
        font-size: 18px;
        line-height: 25px;
        font-weight: 600;
        color: #333333;
        margin-left: 11px;
      }
    }
    .tab_content {
      .swiper-slide {
        .xb {
          padding: 18px 12px 16px 12px;
          background-color: #f2f2f2;
          margin-right: 16px;
          .integral {
            position: relative;
            /*display: flex;
            justify-content: space-between;*/
            span {
              font-size: 12px;
              line-height: 12px;
              color: #777777;
              display: inline-block;
              line-height: 21px;
            }
            .integral_ {
              color: #999999;
              line-height: 17px;
              position: absolute;
              top: 2px;
              right: 0;
            }
            .title {
              font-size: 12px;
              line-height: 12px;
              color: #777777;
            }
          }
          .right_integral {
            margin-bottom: 14px;
            border-bottom: 1px solid #eeeeee;
            .xb__ {
              display: inline-block;
              float: left;
              width: auto;
              margin-right: 12px;
              .title {
                line-height: 21px;
              }
            }
          }
          .fraction {
            font-size: 24px;
            color: #f56d2d;
            line-height: 33px;
            font-weight: 500;
            padding-bottom: 4px;
            margin-bottom: 14px;
            line-height: 37px;
            border-bottom: 1px solid #eeeeee;
            span {
              font-size: 16px;
            }
          }
          .right_fraction {
            color: #f16066;
            line-height: 41px;
            margin-bottom: 0px;
            border-bottom: none;
            span {
              color: #f16066;
            }
          }
          @media screen and (max-width: 320px) {
            .fraction {
              font-size: 18px;
            }
          }
          .xb_coin {
            display: flex;
            .xb_ {
              width: 100px;
              margin-right: 2px;
              p {
                font-size: 12px;
                color: #777777;
                font-weight: 400;
                line-height: 12px;
              }
              .xb_num {
                font-size: 14px;
                font-weight: 500;
                line-height: 14px;
                color: #f16066;
                margin-top: 8px;
              }
              .left_xb_num {
                color: #f56d2d;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 374px) {
    .tab_change {
      margin-bottom: 50px;
    }
  }
  .withdraw {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1;
    .btn- {
      display: flex;
      border-top: 1px solid #eeeeee;
      span {
        flex: 1;
        text-align: center;
        line-height: 49px;
        font-size: 16px;
        color: #999999;
      }
      .btn_l {
        background: #fff;
      }
      .btn_r {
        background: #c49e80;
        color: #fff;
        font-weight: 500;
      }
    }
  }
}
</style>


